import MemberView from './MemberView';
import './MemberView.scss';

export default MemberView;
